// Internal dependencies.
import ISO3166 from '@/filters/iso3166'

// Components.
import Cart from '@/components/cart/component'

export default {
  name: 'main-menu',
  data () {
    return {
      showCurrencySelection: false,
      showLanguageSelection: false,
      showMenu: false
    }
  },
  props: [ 'bordered' ],
  components: { Cart },

  created () {
    document.addEventListener('click', this.documentClickHandler)
    document.addEventListener('click', this.documentClick)
  },

  destroyed () {
    // important to clean up!
    document.removeEventListener('click', this.documentClickHandler)
    document.removeEventListener('click', this.documentClick)
  },

  computed: {
    isQliroEnabled () {
      const hostname = window.location.hostname.toLowerCase()
      const [ topDomain ] = hostname.match(/(localhost|\.\w{2,4}$)/gm)
      return ['.se'].indexOf(topDomain) > -1 && this.$store.getters.currency.currency === 'SEK'
    }
  },

  methods: {
    documentClick (e) {
      let el = this.$refs.slideMenu
      let target = e.target
      if ((el !== target) && !el.contains(target)) {
        this.showMenu = false
      }
    },

    getFlagSrc (lang) {
      let countryISO = ISO3166.languageToCountry(lang)
      return require('../../static/flags/' + countryISO + '.svg')
    },

    toggleLanguageSelection () {
      this.showLanguageSelection = !this.showLanguageSelection
      this.showCurrencySelection = false
    },

    toggleCurrencySelection () {
      this.showLanguageSelection = false
      this.showCurrencySelection = !this.showCurrencySelection
    },

    documentClickHandler (event) {
      // We'll use the ifs as a workaround for the items being closed before they're even shown. Better solution than
      // timeout.
      this.showCurrencySelection = false
      this.showLanguageSelection = false
    },

    // goToLanguage is a helper function to make sure we sync the language selected with the URL to avoid SEO issues.
    goToLanguage (iso) {
      // Extra XSS safety, ignoring ISOs that aren't two-character strings.
      if (!/^[a-z]{2}$/i.test(iso)) {
        return
      }

      const parts = window.location.hostname.split('.')
      const topDomain = parts[parts.length - 1].toLowerCase()
      if (topDomain === 'localhost') {
        this.$store.dispatch('setLanguage', iso)
      } else {
        if (iso === 'sv' && topDomain !== 'se') {
          parts[parts.length - 1] = 'se'
          window.location = window.location.protocol + '//' + parts.join('.')
        } else if (iso === 'en' && topDomain !== 'com') {
          parts[parts.length - 1] = 'com'
          window.location = window.location.protocol + '//' + parts.join('.')
        }
      }
    }
  },
  watch: {
    // Close the cart if we close the backdrop.
    showMenu () {
      if (this.showMenu === true) {
        this.$refs.cart.close()
      }
    },
    '$store.getters.currency.currency': {
      handler: function (newVal) {
        if (this.isQliroEnabled && newVal === 'SEK') {
          this.$store.dispatch('setCheckoutShippingMethod', 'standard')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/script.js